import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

const isRetailVenue = (venue: Venue) => {
  if (!venue.product_line) {
    return false;
  }

  const isRetail =
    venue.product_line !== 'restaurant' &&
    venue.product_line !== 'gift_card' &&
    venue.product_line !== 'charity' &&
    venue.product_line !== 'other';

  return isRetail;
};

export default isRetailVenue;
